module.exports = __webpack_public_path__ + "338c7fdda58cae7d70b0b43ecbf1e616.png";